import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { SurveyStatus } from "./surveyStatus";
import { SurveyName, SurveyNameDTO } from "./surveyName";

export interface SurveyStatusAndNameDTO {
  surveyStatus: SurveyStatus.SurveyStatusDTO;
  surveyName: SurveyNameDTO;
}

export class SurveyStatusAndName {
  readonly isSurveyStatusAndNameSurveyStatusAndName: boolean = true;

  readonly surveyStatus: SurveyStatus.SurveyStatus;
  readonly surveyName: SurveyName;


  constructor(
  surveyStatus: SurveyStatus.SurveyStatus, 
  surveyName: SurveyName
  ) {
    this.surveyStatus = surveyStatus;
    this.surveyName = surveyName;
  }

  static fromDTO(dto: SurveyStatusAndNameDTO): SurveyStatusAndName {
    const surveyStatus = SurveyStatus.fromDTO(getObject(dto, "surveyStatus", InvalidSurveyStatusAndNameSurveyStatusError));
    const surveyName = SurveyName.fromDTO(getObject(dto, "surveyName", InvalidSurveyStatusAndNameSurveyNameError));
    return new SurveyStatusAndName(
      surveyStatus,
      surveyName
    );
  }

  toDTO(): SurveyStatusAndNameDTO {
    const dto: SurveyStatusAndNameDTO = {
        surveyStatus: SurveyStatus.toDTO(this.surveyStatus),
        surveyName: this.surveyName.toDTO()
    };
    return dto;
  }
  }

SurveyStatusAndName.prototype.toString = function toString(): string {
  return `SurveyStatusAndName(surveyStatus='${this.surveyStatus}',surveyName='${this.surveyName}')`;
};

export class InvalidSurveyStatusAndNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyStatusAndNameError";
  }
}
export class InvalidSurveyStatusAndNameSurveyStatusError extends InvalidSurveyStatusAndNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyStatusAndNameSurveyStatusError";
  }
}

export class InvalidSurveyStatusAndNameSurveyNameError extends InvalidSurveyStatusAndNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyStatusAndNameSurveyNameError";
  }
}
